<!-- 標題 & 麵包屑 -->
<div class="row header" #pageHeader>
  <div class="bs-slider-overlay"></div>
  <div class="col-lg-10 col-lg-offset-1 col-md-12">
    <bread-crumb-01 #breadCrumb></bread-crumb-01>
    <h2 class="page-header-b">{{breadCrumb.getSiteMapLatest().name}}</h2>
  </div>
</div>
<!-- /.標題 & 麵包屑 -->
<!-- 區塊:1 圖和下載等說明and基本資訊-->
<section class="row clearfix bg-img">
  <div class="col-lg-10 col-lg-offset-1 col-md-12">
    <div class="search_01" *ngIf="remoteData">
      <!-- 圖片輪播~~有需求的話再un comment
        <ng-container *ngIf="remoteData.images && remoteData.images.length">
        <div class="row m-n">


          <div class="swiper" [tmSwiper]="swiperConfig" [ariaLabel]="''" #imageSwiper="tmSwiper">
            <div class="swiper-button-prev" role="button"
            (click)="imageSwiper.slidePrev()" (keydown.enter)="imageSwiper.slidePrev()"
            [class.swiper-button-disabled]="imageSwiper.activeIndex === 0 || remoteData.images.length <= 1"
            [attr.aria-disabled]="imageSwiper.activeIndex === 0 || remoteData.images.length <= 1"
            [attr.aria-label]="'swiper.prevSlideMessage' | translate"
            [tabindex]="imageSwiper.activeIndex === 0 || remoteData.images.length <= 1 ? -1 : 0"
            ></div>
            <div class="swiper-wrapper">
              <div class="swiper-slide" *ngFor="let rd of remoteData.images; index as i">

                <div class="thumbnail">
                  <div class="image-wrap">
                    <img *ngIf="i < 1" src="{{ rd.url }}" alt="{{remoteData.title}}-{{i+1}}">
                    <ng-container *ngIf="i >= 1">
                      <ng-container *ngIf="isSupportObjectFit">
                        <img class="embed-responsive-item fit_cover swiper-lazy"
                        attr.data-src="{{rd.url}}"
                        src="" alt=""
                        tmObjectFit="cover"
                        tmErrorDefaultImage="/assets/images/no-pic.webp">
                        <div class="swiper-lazy-preloader swiper-lazy-preloader-white"></div>
                      </ng-container>
                      <ng-container *ngIf="!isSupportObjectFit">
                        <div attr.data-background="{{rd.url ? (rd.url) : '/assets/images/no-pic.webp'}}"
                        class="embed-responsive-item swiper-lazy"
                        [style.background-image]="'url(/assets/images/no-pic.webp)'">
                          <div class="swiper-lazy-preloader swiper-lazy-preloader-white"></div>
                        </div>
                      </ng-container>
                    </ng-container>
                  </div>
                </div>
              </div>
            </div>
            <div class="swiper-button-next" role="button"
            (click)="imageSwiper.slideNext()" (keydown.enter)="imageSwiper.slideNext()"
            [class.swiper-button-disabled]="imageSwiper.activeIndex === remoteData.images.length - imageSwiper.viewItemCount || remoteData.images.length <= 1"
            [attr.aria-disabled]="imageSwiper.activeIndex === remoteData.images.length - imageSwiper.viewItemCount || remoteData.images.length <= 1"
            [attr.aria-label]="'swiper.nextSlideMessage' | translate"
            [tabindex]="imageSwiper.activeIndex === remoteData.images.length - imageSwiper.viewItemCount || remoteData.images.length <= 1 ? -1 : 0"
            ></div>
          </div>
        </div>

        <div class="iamhr"></div>
      </ng-container> -->
      <div class="row">
        <div class="col-xs-12 col-sm-6 col-md-6">
          <h2>{{remoteData.title}}</h2>
          <h3 *ngIf="data.menuSetting.subTitle.openStatus && remoteData.subTitle">{{remoteData.subTitle}}</h3>
        </div>

        <div class="col-xs-12 col-sm-6 col-md-6">
          <div class="sharetools">
            <ul>
              <a href="javascript:void(0)" role="button" title="{{'print' | translate}}" (click)="friendlyPrint($event)">
                <li class="share">
                  <img src="/assets/images/v040/print.svg" class="shareicon" alt="" width="55" height="20">
                  <span class="sharew">{{'print' | translate}}</span>
                </li>
              </a>

              <a href="javascript:void(0)" role="button" title="{{'share' | translate}}" (click)="shareToolModal.open()">
                <li class="share">
                  <img src="/assets/images/v040/share.svg" class="shareicon" alt="" width="55" height="20">
                  <span class="sharew">{{'share' | translate}}</span>
                </li>
              </a>

              <a href="javascript:void(0)" role="button" title="{{'visitCount' | translate}}" style="cursor: default;" aria-disabled="true">
                <li class="share"><img src="/assets/images/v040/see_watch.svg" class="visiticon" alt="{{'visitCount' | translate}}" width="55" height="15">
                  <span class="sharew">{{(remoteData.viewCount)? remoteData.viewCount : '0'}}</span>
                </li>
              </a>
            </ul>
          </div>
        </div>
      </div>

      <ng-container *ngIf="data.menuSetting.description.openStatus && remoteData.description">
        <p>{{ remoteData.description }}</p>
      </ng-container>

      <div class="row m-n fr-view" [innerHTML]="$any(remoteData.content | safe: 'html')"></div>

      <div class="row m-n">

        <p *ngIf="data.menuSetting.dataProvider.openStatus && remoteData.dataProvider">
          {{ data.menuSetting.dataProvider.title }}：{{ remoteData.dataProvider }}
        </p>

        <ng-container *ngIf="data.menuSetting.keywords.openStatus && remoteData.keywords?.length">
          <h3>{{'single.keywords' | translate}}</h3>
          <label for="keywords" id="keywordsLabel" (click)="keywordsList.focus()" class="sr-only">{{'single.keywords' | translate}}</label>
          <ul id="keywords" aria-labelledby="keywordsLabel" role="listbox" tabindex="-1" #keywordsList>
            <ng-container *ngFor="let keyword of remoteData.keywords">
              <li>#{{keyword}}</li>
            </ng-container>
          </ul>
        </ng-container>

        <ng-container *ngIf="data.menuSetting.categories.openStatus && remoteData.categories?.length">
          <h3>{{'single.categories' | translate}}</h3>
          <label for="categories" id="categoriesLabel" (click)="categoriesList.focus()" class="sr-only">{{'single.keywords' | translate}}</label>
          <ul id="categories" aria-labelledby="categoriesLabel" role="listbox" tabindex="-1" #categoriesList>
            <ng-container *ngFor="let category of remoteData.categories">
              <li>{{category}}</li>
            </ng-container>
          </ul>
        </ng-container>
      </div>
    </div>
  </div>
</section>
<!-- /.區塊:1 -->

  <app-share-social-modal #shareToolModal></app-share-social-modal>
